<style scoped>
.content {
  height: calc(100vh - 88px);
  width: 100%;
  margin: 0;
  padding: 0;
}
.swatche {
  overflow: hidden;
}
.visualViewer {
  margin: 0;
  padding: 0;
  height: 100% !important;
  position: relative;
}
</style>

<template>
  <div class="swatche">
    <Loader v-if="loading"></Loader>
    <AppBar v-on:TotalSearch="totalSearch">
      <template v-slot:app-toolbar-title>Veille Projets Capture CO2</template>
    </AppBar>
    <div ref="content" class="content">
      <v-system-bar color="primary">
        <v-icon title="visualiser sous la forme d'un tableau" v-on:click="displayModeLeft = 'tableau'"
          icon="mdi-table"></v-icon>
        <v-icon title="visualiser sous la forme d'une liste" v-on:click="displayModeLeft = 'list'"
          icon="mdi-view-list"></v-icon>
        <v-spacer></v-spacer>
        <v-icon title="visualiser sous la forme d'une timeline" v-on:click="displayModeRight = 'time'"
          icon="mdi-clock-time-eight"></v-icon>
        <v-icon title="visualiser sous la forme d'une cartographie" v-on:click="displayModeRight = 'map'"
          icon="mdi-map"></v-icon>
      </v-system-bar>
      <div style="height: calc(100vh - 160px); position: relative;">
        <Face2Face>
          <template v-slot:both-container-item> <i class="fas fa-asterisk" title="both" /> </template>
          <template v-slot:left-container-item> <i class="fas fa-table" title="datatable" /> </template>
          <template v-slot:right-container-item> <i class="fas fa-location" title="network" /> </template>
          <template v-slot:leftSide ref="countriesTable">
            <div class="visualViewer">
              <Datatable v-if="displayModeLeft === 'tableau'" :headers="headerTable" :items="selectedDatasVeilleCO2"
                v-on:lineClick="handleLineClick"></Datatable>
              <liste-project-swatche v-if="displayModeLeft === 'list'"
                v-bind:selectedItemsVeilleCO2="selectedDatasVeilleCO2" v-on:clicEnSavoirPlus="handleLineClick"
                v-on:clicFocusVille="handleMapFocus"></liste-project-swatche>
            </div>
          </template>
          <template v-slot:rightSide>
            <div class="visualViewer">
              <Geospacial v-if="displayModeRight === 'map'" :assign-zoom="6" :assign-center="mapFocusOn"
                :incomingPositions="data2map" v-on:clickMarker="captureClickMarker"></Geospacial>
              <!--timeline-swatche v-if="displayModeRight === 'time'"  :incoming-filtred-data="selectedDatasVeilleCO2" v-on:clickEvent="handleLineClick"></timeline-swatche-->
              <Visualtimeline v-if="displayModeRight === 'time'" :incoming-events="data2Timeline"
                v-on:clickEvent="handleTimelineEventClick"></Visualtimeline>
            </div>
          </template>
        </Face2Face>
      </div>
      <filtresSwatche v-bind:datas="datasVeilleCO2" v-on:clickRecherche="captureClickRecherche" style="height: 73px;">
      </filtresSwatche>
      <v-dialog v-model="dialog" transition="dialog-bottom-transition">
        <Project :incoming-project="currentLine" v-on:close="closeDialog"></Project>
      </v-dialog>
      <v-dialog v-model="dialogListProject" transition="dialog-bottom-transition" max-width="500">
        <v-card>
          <v-card-text>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item v-for="tile in listProjectInThisLocation" :key="tile.id" v-on:click="handleLineClick(tile)"
                  style=" border-bottom: 1px solid #000000">
                  <v-list-item-content>
                    <p :style="{ width: 'fit-content', color: '#154985' }"><strong>{{ tile.Projet }} </strong></p>
                    <v-chip label class="mr-2" size="small" variant="elevated" color="#86B404"
                      v-for="val in tile['Type de projet'].split(';#')">{{ val }}</v-chip><br>
                    <em> {{ tile["Porteur(s) du projet"] }}</em>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import AppBar from "../_common/AppBar";
import Face2Face from "../../components/common/positionning/Face2Face";
import Loader from "../../components/common/Loader";
import Geospacial from "../../components/common/viewers/geospatial/Geospacial";
import Datatable from "../../components/common/viewers/datatable/Datatable";
import Visualtimeline from "../../components/common/viewers/visualtimeline/Visualtimeline";
import listeProjectSwatche from "./parts/listeProjectSwatche";
import filtresSwatche from "./parts/filtresSwatche";
import Project from "./parts/Project";
import { fetchVeilleCO2, Test } from "../../backend/mainAPI"


let configHeader = [
  { text: 'Projet', value: 'Projet' },
  { text: 'Type de projet', value: 'Type de projet' },
  { text: 'Situation géographique', value: 'Situation géographique' },
  { text: 'Année de demarrage', value: 'Date de départ' },
  { text: 'Année de cloture', value: 'Date de FIN' },
  { text: 'Porteur(s) du projet', value: 'Porteur(s) du projet' },
  { text: 'statut', value: 'statut' }];

export default {
  name: 'SWatchE',
  components: { Loader, AppBar, Face2Face, Geospacial, Datatable, Project, listeProjectSwatche, filtresSwatche, Visualtimeline },
  data: () => ({
    loading: false,
    datasVeilleCO2: [],
    search: "",
    tableHeight: 400,
    currentLine: null,
    dialog: false,
    dialogListProject: false,
    displayModeRight: 'map',
    displayModeLeft: 'tableau',
    listProjectInThisLocation: null,
    headerTable: configHeader,
    selectedFilters: null,
    mapFocus: { "Latitude": 48.866, "Longitude": 4.159 },
    colors: { "Captage": "#86B404", "Stockage": "#154985", "Transport": "white", "Utilisation": "grey" },


  }),
  computed: {
    data2map() {
      let dataToMap = [];
      let groupByCountries = this.groupByCity(this.selectedDatasVeilleCO2, "Situation géographique")
      this.selectedDatasVeilleCO2.forEach((item) => {
        if (item["Situation géographique"] && item["Longitude"] && item["Latitude"]) {
          dataToMap.push({
            projet: item["Projet"],
            countryFr: item["Situation géographique"],
            coordinates: [
              item["Latitude"] ? item["Latitude"] : "-",
              item["Longitude"] ? item["Longitude"] : "-",
            ],
            number: groupByCountries[item["Situation géographique"]].length,
            projects: groupByCountries[item["Situation géographique"]]
          })
        }

      });
      dataToMap.forEach(item => {
        item["colors"] = []
        item["projects"].forEach(projet => {
          if (projet["catégories de la technologie"]) {
            projet["catégories de la technologie"].split(',').forEach(elem => {
              elem = elem.trim();
              if (Object.keys(this.colors).includes(elem)) {
                if (!item["colors"].includes(this.colors[elem])) {
                  item["colors"].push(this.colors[elem])
                }
              } else {
                if (item["colors"].length == 0) {
                  item["colors"].push("black")
                }
              }
            });
          } else {
            if (item["colors"].length == 0) {
              item["colors"].push("black")
            }
          }
        });
      })
      return dataToMap;
    },

    data2Timeline() {
      let dataToTime = [];
      this.selectedDatasVeilleCO2.forEach((item, key) => {
        let start, end;
        if ((item["Projet"] !== null) && (item["Projet"] !== "") && (item["Date de départ"] !== "")) {
          start = (item["Date de départ"]) && (item["Date de départ"] !== null) && (item["Projet"] !== null) && (item["Projet"] !== "") && (item["Date de départ"] !== "") ? new Date(this.setDateFormat(item["Date de départ"])) : false;
          end = (item["Date de FIN"] !== null) && (item["Date de FIN"] !== "") && (item["Date de FIN"] !== item["Date de départ"]) ? new Date(this.setDateFormat(item["Date de FIN"])) : false;
          let itemForTimeline = {
            id: key,
            content: item["Projet"],
            start: start,
            title: item["Projet"]
          };
          dataToTime.push(itemForTimeline)
        }
      });
      return dataToTime;
    },

    selectedDatasVeilleCO2() {
      let selectedDatsVeilleCO2 = [];
      if (this.selectedFilters !== null) {
        selectedDatsVeilleCO2 = this.datasVeilleCO2.filter((item) => this.compareAnItemWithSelectedFilters(item, this.selectedFilters))
      } else {
        selectedDatsVeilleCO2 = this.datasVeilleCO2;
      }
      return selectedDatsVeilleCO2;
    },

    mapFocusOn() {
      return this.mapFocus
    }
  },

  mounted() {
    this.tableHeight = this.$refs.content.clientHeight;
    this.loadData();
  },

  watch: {
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;
        fetchVeilleCO2((result) => {
          result.data.forEach((item, key) => {
            try {
              item["Situation géographique"] = JSON.parse(item["Situation géographique"]);
              item["Longitude"] = JSON.parse(item["Longitude"]);
              item["Latitude"] = JSON.parse(item["Latitude"]);
              item["Type de projet"] = JSON.parse(item["Type de projet"]);
              item["Mode de Captage"] = JSON.parse(item["Mode de Captage"]);
              item["Utilisation: Conversion"] = JSON.parse(item["Utilisation: Conversion"]);
              item["Stockage"] = JSON.parse(item["Stockage"]);
              item["Transports"] = JSON.parse(item["Transports"]);

            } catch (e) { }
          });
          this.datasVeilleCO2 = result.data;
          this.datasVeilleCO2.forEach((item) => {

            if (item["Longitude"]) {
              if (item["Longitude"].includes(',')) {
                item["Longitude"] = item["Longitude"].replace(',', '.');
                item["Latitude"] = item["Latitude"].replace(',', '.');
              }
            }
          })
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    handleLineClick(value) {
      this.currentLine = value;
      this.dialog = true;
      this.dialogListProject = false
    },

    handleTimelineEventClick(properties) {
      this.currentLine = this.datasVeilleCO2[properties.item];
      this.dialog = true;
    },

    handleMapFocus(item) {
      this.mapFocus = { "Latitude": item["Latitude"], "Longitude": item["Longitude"] }
    },

    captureClickMarker(marker) {
      this.dialogListProject = true;
      this.listProjectInThisLocation = marker.projects
    },

    captureClickRecherche(selectedFilters) {
      if (selectedFilters && this.datasVeilleCO2) {
        this.selectedFilters = selectedFilters;
      }
    },

    compareAnItemWithSelectedFilters(item, selectedFilters) {
      let thisItemCorrespondToFilter = true;
      let keys = Object.keys(selectedFilters)

      keys.forEach((key) => {
        if ((key !== "Date de départ") && (key !== "Situation géographique") && (key !== "catégories de la technologie") && !selectedFilters["TotalSearch"] && (item[key] !== selectedFilters[key])) {
          thisItemCorrespondToFilter = false;
        }
        else if (key === "Date de départ" && !item[key] || key === "Date de départ" && new Date(item[key]).getFullYear().toString() != selectedFilters[key]) {
          thisItemCorrespondToFilter = false;
        }
        else if (key === "Situation géographique" && !item[key] || key === "Situation géographique" && item[key] !== selectedFilters[key]) {
          thisItemCorrespondToFilter = false;
        }
        else if (key === "catégories de la technologie" && !item[key] || key === "catégories de la technologie" && item[key].includes(selectedFilters[key]) != true) {
          thisItemCorrespondToFilter = false;
        }
        else if (key === "TotalSearch" && this.searchInObject(item, selectedFilters[key]) != true) {
          thisItemCorrespondToFilter = false;
        }
      })
     
      return thisItemCorrespondToFilter;
    },

    groupByCity(dataVeilleCO2, firstKey) {
      let correctDataWithCities = [];
      dataVeilleCO2.forEach((item) => {
        if (item["Situation géographique"]) {
          correctDataWithCities.push(item)
        }
      })
      //@todo Chercher à généraliser la fonction groupByAttributeName dans le fichier ../../helpers pour se débarasser de cette methode
      let groupByCity = correctDataWithCities.reduce(
        (result, item) => ({
          ...result,
          [item[firstKey]]: [
            ...(result[item[firstKey]] || []),
            item,
          ],
        }),
        {},
      );
      return groupByCity;
    },

    closeDialog() {
      this.dialog = false
    },
    
    totalSearch(searchedItem) {
      if (searchedItem && searchedItem != "" & searchedItem != " ") {
        this.selectedFilters = { "TotalSearch": searchedItem }
      } else this.selectedFilters = {}
    },

    searchInObject(obj, searchString) {
      const searchStringLower = searchString.toLowerCase();

      for (const key in obj) {
        if (typeof obj[key] === 'object') {
          const result = searchInObject(obj[key], searchStringLower); 
          if (result) {
            return true;
          }
        } else if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searchStringLower)) {
           return true;
        }
      }
      return false;
    },

    setDateFormat(dateInitiale) {
      let parties = dateInitiale.split('/');
      let jour = parties[0];
      let mois = parties[1];
      let annee = parties[2];
      let nouvelleDate = mois + "/" + jour + "/" + annee;
      return nouvelleDate;
    }

  }
}
</script>
